export const blueTextFieldStyles = (theme) => ({
  mt: 1,
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#fff",
    "& fieldset": {
      borderColor: theme.palette.other.figmaBlue,
    },
    "&:hover fieldset": {
      borderColor: theme.palette.other.figmaBlue,
    },
    "&.Mui-focused fieldset": {
      borderColor: theme.palette.other.figmaBlue,
    },
  },
  "& .MuiInputLabel-root": {
    color: theme.palette.other.figmaBlue,
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: theme.palette.other.figmaBlue,
  },
});